import React from "react";
import PersonalDataComponent from './components/PersonalDataComponent';

export default function PersonalData () {
    return (
        <PersonalDataComponent />
    );
}